import { ApiClient } from '@k2/common/backend/api-client';

export class AssignmentServiceTransactionEndpoint {
  constructor(private api: ApiClient) {

  }

  getTransactionsOverview = (assignmentServiceInstanceId: number) => {
    return this.api.get(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction`);
  };

  getFormCreateAssignmentServiceTransactionPurchase = (assignmentServiceInstanceId: number) => {
    return this.api.getWithoutCache(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/purchase/form-create`);
  };

  createAssignmentServiceTransactionPurchase = (assignmentServiceInstanceId: number, data: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/purchase`, data);
  }

  getFormUpdateAssignmentServiceTransactionPurchase = (assignmentServiceTransactionId: number) => {
    return this.api.getWithoutCache(`/assignment-service-transaction/${assignmentServiceTransactionId}/purchase/form-update`);
  };

  updateAssignmentServiceTransactionPurchase = (assignmentServiceTransactionId: number, data: any) => {
    return this.api.patch(`/assignment-service-transaction/${assignmentServiceTransactionId}/purchase/update`, data);
  }

  getFormCancelAssignmentServiceTransactionPurchase = (assignmentServiceTransactionId: number) => {
    return this.api.getWithoutCache(`/assignment-service-transaction/${assignmentServiceTransactionId}/purchase/form-cancel`);
  };

  cancelAssignmentServiceTransactionPurchase = (assignmentServiceTransactionId: number, data: any) => {
    return this.api.patch(`/assignment-service-transaction/${assignmentServiceTransactionId}/purchase/cancel`, data);
  }

  getFormCreateAssignmentServiceTransactionSales = (assignmentServiceInstanceId: number) => {
    return this.api.getWithoutCache(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/sales/form-create`);
  };

  createAssignmentServiceTransactionSales = (assignmentServiceInstanceId: number, data: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/sales`, data);
  }

  getFormUpdateAssignmentServiceTransactionSales = (assignmentServiceTransactionId: number) => {
    return this.api.getWithoutCache(`/assignment-service-transaction/${assignmentServiceTransactionId}/sales/form-update`);
  };

  updateAssignmentServiceTransactionSales = (assignmentServiceTransactionId: number, data: any) => {
    return this.api.patch(`/assignment-service-transaction/${assignmentServiceTransactionId}/sales/update`, data);
  }

  getFormCancelAssignmentServiceTransactionSales = (assignmentServiceTransactionId: number) => {
    return this.api.getWithoutCache(`/assignment-service-transaction/${assignmentServiceTransactionId}/sales/form-cancel`);
  };

  cancelAssignmentServiceTransactionSales = (assignmentServiceTransactionId: number, data: any) => {
    return this.api.patch(`/assignment-service-transaction/${assignmentServiceTransactionId}/sales/cancel`, data);
  }

  getFormCreateAssignmentServiceTransactionPurchaseRecurring = (assignmentServiceInstanceId: number) => {
    return this.api.getWithoutCache(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/purchase-recurring/form-create`);
  };

  createAssignmentServiceTransactionPurchaseRecurring = (assignmentServiceInstanceId: number, data: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/purchase-recurring`, data);
  }

  groupMultipleAssignmentServiceTransaction = (assignmentServiceInstanceId: number, data: any) => {
    return this.api.post(`/assignment-service-instance/${assignmentServiceInstanceId}/assignment-service-transaction/group-multiple`, data);
  }

  ungroupAssignmentServiceTransaction = (assignmentServiceTransactionId: number) => {
    return this.api.post(`/assignment-service-transaction/${assignmentServiceTransactionId}/ungroup`, {});
  }
}
